import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAeeTRQj0SCMfBPxA2qdpWVmpoEYVXLDWA",
  authDomain: "brokkerspot-6bc24.firebaseapp.com",
  projectId: "brokkerspot-6bc24",
  storageBucket: "brokkerspot-6bc24.firebasestorage.app",
  messagingSenderId: "625855875282",
  appId: "1:625855875282:web:63e0a8e18a207e445f850b",
  measurementId: "G-WYHZJ9QK19",
};

export const firebaseApp = initializeApp(firebaseConfig);

/** Resolves to Analytics instance when supported, otherwise null. */
export const analyticsReady = isSupported().then((supported) => {
  if (!supported) return null;
  return getAnalytics(firebaseApp);
});

/** @deprecated Prefer analyticsReady — kept for existing imports */
export let analytics = null;
analyticsReady.then((instance) => {
  analytics = instance;
});

/** Fire a custom Analytics event (no-op if Analytics unavailable). */
export async function logFirebaseEvent(eventName, params = {}) {
  const instance = await analyticsReady;
  if (!instance) return false;
  logEvent(instance, eventName, params);
  return true;
}
